import { z } from 'zod';
import { metadata } from '../content/helpers';

const articleCategorySection = z.object({
  label: z.string(),
  href: z.string(),
});

const articleCategoryContentData = z.object({
  metadata,
  data: z.object({
    name: z.string(),
    description: z.string(),
    sections: z.array(articleCategorySection),
  }),
});

export const articleCategorySchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1, 'Name is required').max(100),
  slug: z.string().min(1, 'Slug is required'),
  parent_id: z.number().int().positive().nullable().optional(),
  content: z.object({
    en: articleCategoryContentData,
    es: articleCategoryContentData,
  }),
});

export type ArticleCategoryInput = z.infer<typeof articleCategorySchema>;
